import { Col, Row } from '@/components/grid/grid-component';
import { BsCheck } from 'react-icons/bs';
import ReactPhoneInput from 'react-phone-number-input';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  justify-items: center;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
`;

const GoBack = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const PhoneNumberContainer = styled.div`
  display: flex;
`;

const RowStyle = styled(Row)`
  width: 100% !important;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK} !important;
  margin-bottom: 25px !important;
  padding: 24px !important;
  margin-right: 0px !important;
  margin-left: 0px !important;
  justify-content: end !important;
`;

const Main = styled.div`
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
  min-height: 100%;
  margin-top: 20px;
  justify-content: center;
  width: 100%;
`;

const DivStyle = styled(Col)`
  display: flex;
  flex-direction: column;
  margin: 0 0 32px 0;
`;

const PhoneInput = styled(ReactPhoneInput)`
  .PhoneInputInput {
    display: none;
  }

  .PhoneInputCountrySelectArrow {
    display: none;
  }

  .PhoneInput-color--focus {
    border-color: #eaedf3;
  }

  .PhoneInputCountryIconImg {
    border-radius: 4px;
  }

  .PhoneInputCountryIcon--border {
    border: none;
    border-radius: 4px;
    background-color: #eaedf3;
  }

  .PhoneInputCountry {
    display: flex;
    justify-content: center;
    border-radius: 4px 0 0 4px;
    margin: 0;
    border-right: none;
    margin-right: 6px;
  }
`;

const SuppliersContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
`;
const mainStyledCol = {};

const CheckboxContainer = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 24px;
`;

const Checkbox = styled.div`
  display: flex;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY};
  border-radius: 2px;
  background-color: ${({ theme }) => theme.COLOR_BLACK};
`;

const CheckMark = styled(BsCheck)`
  margin: 1px;
  height: 20px;
  width: 20px;
  color: ${({ theme }) => theme.COLOR_WHITE};
`;

const CheckboxLabel = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  margin-left: 13px;
  letter-spacing: 0.2px;
  color: ${({ theme }) => theme.COLOR_BLACK};
`;

const ActionsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 8px 1px 24px 4px;
`;

const CompanyPrimary = styled.div`
  background-color: ${({ $color, theme }) => $color ?? theme.COLOR_PRIMARY};
  border-radius: 50%;
  border: 2px solid white;
  height: 32px;
  right: 20px;
  z-index: 1;
  position: absolute;
  width: 32px;
  box-shadow: 0px 3px 10px 0px #0000001a;
`;

const CompanySecondary = styled.div`
  background-color: black;
  border-radius: 50%;
  border: 2px solid white;
  height: 32px;
  right: 0;
  position: absolute;
  width: 32px;
  background-color: ${({ $color, theme }) => $color ?? theme.COLOR_SECONDARY};
`;

const CompanyColors = styled.div`
  position: relative;
  bottom: 3px;
  min-width: 60px;
  display: flex;
`;

const LogoContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const CompanyLogo = styled.img`
  display: block;
  height: 185px;
  max-width: 260px;
  width: auto;
  border: 1px solid ${({ theme }) => theme.COLOR_GREY5};
  border-radius: 4px;
`;

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDiv = {
  Div,
  RowStyle,
  Main,
  DivStyle,
  PhoneInput,
  PhoneNumberContainer,
  mainStyledCol,
  SuppliersContainer,
  CheckboxContainer,
  Checkbox,
  CheckMark,
  CheckboxLabel,
  GoBack,
  ActionsContainer,
  CompanyPrimary,
  CompanySecondary,
  CompanyColors,
  LogoContainer,
  CompanyLogo,
  LinkContainer,
};

export default StyledDiv;
